import * as types from './mutation-types';

const logout = (state) => {
    localStorage.removeItem("access_token");
    localStorage.removeItem("user");

    // Local environment
    const hostname = window.location.hostname.toLowerCase();
    if (hostname === 'localhost' || hostname === '127.0.0.1') {
        window.location.href = "http://partenaires.dynassurances.local/login";
        return;
    }

    let origin = state.userInfo.origin_login;
    const mechanic = state.userInfo && state.userInfo.mechanic;
    const representative = state.userInfo && state.userInfo.representative;

    const specialite = (mechanic && mechanic.specialite)
        ? mechanic.specialite.toLowerCase()
        : ((representative && representative.specialite)
            ? representative.specialite.toLowerCase()
            : '');

    if (
        specialite &&
        (
            specialite.includes('camping-car') ||
            specialite.includes('cc') ||
            specialite.includes('camping car')
        )
    ) {
        window.location.href = "https://assur-camping-car.fr/espace-professionnel/";
    } else {
        window.location.href = "https://assur-garantiesmecaniques.fr/espace-professionnel/";
    }
};

export const mutations = {
    [types.BASE_URL](state, url) {
        state.baseUrl = url
    },

    [types.SIGN_IN](state, user) {
        localStorage.setItem("access_token", user.access_token);
        localStorage.setItem("user", JSON.stringify(user.data));
        state.userInfo = user.data
    },

    [types.SIGN_OUT](state) {
        logout(state)
    },

    [types.SESSION_EXPIRED](state) {
        logout(state)
    },

    [types.UPDATE_USER_INFO](state, user_payload) {
        state.userInfo = user_payload
    },

    [types.TOKEN_REFRESHING](state, status) {
        state.isTokenRefreshing = status;
    },

    [types.UPDATE_CALC_GARANTIES](state, quotes) {
        state.quotes = quotes;
    },

    [types.TOKEN_UPDATED](state, moment) {
        state.last_token_updated = moment;
    },

    [types.BACK_TO_DEVIS_ENABLE](state) {
        state.backToDevisListActive = true;
    },
    [types.BACK_TO_DEVIS_DISABLE](state) {
        state.backToDevisListActive = false;
    },
    [types.UPDATE_DRIVING_SCHOOL_INFO](state, payload) {
        state.userInfo.driving_school = payload;
    },
    [types.UPDATE_REPRESENTATIVE_INFO](state, payload) {
        state.userInfo.representative = payload;
    },
    [types.UPDATE_REPRESENTATIVE_VERIFICATION_DOCUMENTS](state, payload) {
        state.userInfo.representative.verification_documents = payload;
    },
};



// WEBPACK FOOTER //
// ./src/store/mutations.js